export default [
    {
        title: 'Account Users',
        icon: 'FileIcon',
        route: { name: 'account-user-list' },
        action: 'read',
        resource: 'AccountUser',
    },
]
